export const getTotalDurationForSongFiles = (files) => {
    if (!files) {
        return 0;
    }

    return files.reduce((count, file) => {
        if (!file.song) {
            return count;
        }

        return count + file.song.duration;
    }, 0);
};

export const getDurationPerImage = (block, songs) => {
    let totalDuration = block.duration;
    const parent = block.parent_block;

    const photo_calculation = getSettingByName(block, 'photo_calculation');
    const duration_per_photo = photo_calculation && photo_calculation.value === 'custom' ? getSettingByName(block, 'duration_per_photo') : {value: 5};

    // get duration per photo setting and check if there is not any music.
    if (block.settings && duration_per_photo) {

        // if we have a non dirty value return it. Otherwise check if we have music we don't have any music return the default setting
        if (photo_calculation && photo_calculation.value === 'custom') {
            return duration_per_photo.value;
        } else if (parent && parent.files && !parent.files.length && duration_per_photo.dirty === 0) {
            return duration_per_photo.value;
        }
    }

    if (parent && (parent.type === 5 /*Inloop en uitloop */ || parent.type === 6 /*condolence */)) {
        totalDuration = getTotalDurationForSongFiles(songs) ? getTotalDurationForSongFiles(songs) : block.block_duration;
    } else {
        totalDuration = totalDuration ? totalDuration : getTotalDurationForSongFiles(songs);
    }

    if (!totalDuration) {
        totalDuration = block.total_duration;
    }

    const totalPhotosInBlock = block.files.filter(function (file) {
        return (file.extension === 'jpg' || file.extension === 'png' || file.extension === 'jpeg');
    });

    const totalImages = totalPhotosInBlock.length;
    const amount = totalDuration / totalImages;


    if (!isNaN(amount)) {
        return amount;
    }

    return 0;
};


export const getSettingByName = (block, setting_name) => {
    return block.settings.find((setting => {
        return (setting.name === setting_name);
    }));
};

export function getPlaylistItemForDuration(playlistItems, maxDuration, durationToFind) {
    // Determine the total duration in the playlist
    const totalDurationInPlaylist = playlistItems.reduce((duration, playlist) => {
        if (playlist.sources) {
            return duration + playlist.sources[0].duration;
        }

        return duration + (playlist.duration || 0);
    }, 0);

    // Get the max duration
    const cappedMaxDuration = maxDuration ? maxDuration : totalDurationInPlaylist;
    // How many time do we duplicate the playlist to fit the duration
    const timesToClone = Math.max(Math.ceil(cappedMaxDuration / Math.max(totalDurationInPlaylist, 1)), 1);

    // Create the full duration playlist
    const fullDurationPlaylist = [].concat.apply([], Array(timesToClone).fill([...playlistItems]));

    // Find the video index to use
    let durationToCheck = 0;
    let videoIndex = 0;

    while (videoIndex < fullDurationPlaylist.length) {
        const playlistDuration = Math.max(fullDurationPlaylist[videoIndex].duration || fullDurationPlaylist[videoIndex].sources[0].duration, 1);

        if (durationToCheck + playlistDuration >= durationToFind) {
            break;
        }

        durationToCheck += playlistDuration;
        videoIndex++;
    }

    return {
        playlistItem: fullDurationPlaylist[videoIndex],
        offset: durationToCheck
    };
}
